<template>
<loading-overlay :active="isLoading" :is-full-page="true" :width="128" :height="128" loader="spinner" color="rgb(var(--color-active-hsl-128))" background-color="rgb(var(--color-b-back))" />
  <SrcBackgroundScroll @scrolled="isShrunk = $event">
      <HeadlineSubScroll 
          :title="$t('settings.modbus')" 
          target="/Settings" 
          :hassubline="!isShrunk"
          :hasmenu="false"
          :isShrunk="isShrunk"
          >
            <template #icon>
              <IconModbus             
                class="transition-all duration-300"
                :class="isShrunk ? 'w-8 h-8' : 'w-12 h-12'"/>
            </template>
            <template #subline>
              {{ $t('settings.settingsfor',{wallbox:this.decodeHtml(this.$store.state.WbName)} ) }}
            </template>
      </HeadlineSubScroll>

    <ConfirmLeaveModal
      v-model:show="showLeaveDialog"
      :pendingNavigation="this.leaveDialog"
    />

    <SettingsHeader v-if="!isLoading" :admin="this.$store.state.Role=='admin'">
      {{ this.decodeHtml(this.$store.state.WbName) }}
    </SettingsHeader>

    <SettingsBody v-if="!isLoading">
      <template v-slot:formgrid>
          <div class="mt-2 mb-2">

            <ToggleWithLabel 
              v-model="modbusmode"
              :label="$t('setmodbus.modbusonoff')"
              :ontext="$t('common.on')"
              :offtext="$t('common.off')"
              @update:modelValue ="onChange"
            />
          </div>
          <div class="mt-2 mb-2">
            <ActionButton @click="downloadmodbus()">
            {{ $t('setmodbus.modbusdownload') }}
            </ActionButton>
          </div>

          <div class="form-group sm:col-span-2">
            <TextfieldWithLabel
              :text="$t('setmodbus.helptext',{ip: ipadress })"
            />
          </div>
          <div class="form-group sm:col-span-2 mb-6">
            <SelectWithLabelIcon
                v-model="modbus_auth"
                :disabled="!modbusmode"
                :label="$t('setmodbus.auth')"
              @update:modelValue ="onChange"
              >
              <template v-slot:options>
                <option value="0" selected>{{ $t('setmodbus.auth0') }}</option>
                <option value="1">{{ $t('setmodbus.auth1') }}</option>
                <option value="2">{{ $t('setmodbus.auth2') }}</option>
              </template>
            </SelectWithLabelIcon>
          </div>

        </template>
        <template v-slot:formbottom>
          <div class="w-full mt-6">  
            <ActionButton :disabled="!isDirty" @click="savemodbus()">
            {{ $t('common.save') }}
            </ActionButton>
          </div>
        </template>
    </SettingsBody>
</SrcBackgroundScroll>
</template>

<script>
import SrcBackgroundScroll from './sources/SrcBackgroundScroll.vue'
import HeadlineSubScroll from './elements/HeadlineSubScroll.vue'
import IconModbus from './icons/IconModbus.vue'
import SettingsHeader from './elements/SettingsHeader.vue'
import SettingsBody from './elements/SettingsBody.vue'
import ActionButton from './elements/ActionButton.vue'
import TextfieldWithLabel from './elements/TextfieldWithLabel.vue'
import ToggleWithLabel from './elements/ToggleWithLabel.vue'
import SelectWithLabelIcon from './elements/SelectWithLabelIcon.vue'
import ConfirmLeaveModal from './elements/ConfirmLeaveModal.vue'
import { useI18n } from 'vue-i18n'
export default {
  setup () {
      const { t,d,n } = useI18n()
      return { t,d,n }
    },
  components: {
    SrcBackgroundScroll, HeadlineSubScroll, IconModbus,
    SettingsHeader, SettingsBody, ActionButton, 
    TextfieldWithLabel, ToggleWithLabel, SelectWithLabelIcon, ConfirmLeaveModal
    },

  data() {
    return {
          isLoading: false,
          saveto: this.$store.state.WbId,
          modbus_onoff: 0,
          modbus_auth: 0,       
          modbusmode: false,
          ipadress: '',
          isShrunk: false,

          isDirty:false,
          showLeaveDialog:false
      }
  },
  beforeRouteLeave(to, from, next) {

    if (this.isDirty || this.editmode) {
      this.showLeaveDialog = true;
      this.pendingNavigation = next;    
    } else {
      next();
    }
  },
  computed: {
  },
  methods: {
    onChange() {this.isDirty = true;},
    leaveDialog(){this.pendingNavigation();},
    decodeHtml: function(html) {
      let txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
      },
    downloadmodbus() {
      const pdfUrl = 'wallbox/download/Modbus-Server.pdf';
      const link = document.createElement('a');
      link.href = pdfUrl;
      //link.setAttribute('download', 'Modbus-Server.pdf');
      link.setAttribute("target", "_blank");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    savemodbus() {
      this.isDirty = false;
      if(this.modbusmode){
        this.modbus_onoff=1;
      }
      else{
        this.modbus_onoff=0;
      }
      this.axios
      .get('wallbox/settings.php?action=sync_modbus&client='+this.$store.state.WbId+'&enabled='+this.modbus_onoff+'&auth_mode='+this.modbus_auth+'&user='+this.$store.state.token)
      .then((response) => {      
                  if(response.data.status=='ok'){
                    console.log('Modbus Settings gespeichert');
                  }else{
                    console.log('Fehler beim speichern der Modbus Settings');                   
                  }
                })
      .catch((errors) => {
          console.log(errors); // Errors
      });
    },
  },
  
  created() {  
      this.isLoading = true;
      let client_networkUrl = 'wallbox/info.php?action=get_network&user='+this.$store.state.token+'&client='+this.$store.state.WbId;
      let client_modbusUrl = 'wallbox/info.php?action=get_modbus&user='+this.$store.state.token+'&client='+this.$store.state.WbId;
      const requestclient_network = this.axios.get(client_networkUrl);
      const requestclient_modbus = this.axios.get(client_modbusUrl);
      this.axios
          .all([requestclient_network,requestclient_modbus])
          .then(
              this.axios.spread((...responses) => {
                  const responseclient_network = responses[0];
                  const responseclient_modbus = responses[1];

                  if(responseclient_network.data.status=='token'){
                        this.$router.push({path: '/'});             
                  }else if(responseclient_network.data.status=='ok'){
                    this.ipadress = responseclient_network.data.tbl_networksettings.ip;        
                  }else{
                    console.log('Error get Client Network Table');
                  }

                  if(responseclient_modbus.data.status=='token'){
                        this.$router.push({path: '/'});             
                  }else if(responseclient_modbus.data.status=='ok'){
                    this.modbus_onoff=responseclient_modbus.data.tbl_modbus_server.enabled;
                    this.modbus_auth=responseclient_modbus.data.tbl_modbus_server.authMode;
                    if(this.modbus_onoff==1)
                      this.modbusmode=true;
                    else
                      this.modbusmode=false;
                  }else{
                    console.log('Error get Client Modbus Settings');
                  }                  

              this.isLoading = false;
              })
          )
          .catch((errors) => {
              this.isLoading = false;
              console.error(errors);
          }
        
        
        );





  },
};
</script>
<style scoped>
</style>
